import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import { useState, createContext } from 'react';
import SignIn from './components/signIn';
import Dashboard from './components/dashboard';
import ManageUser from './components/manage-user';
import ManageConge from './components/manage-conge';
import { createTheme, ThemeProvider } from '@mui/material/styles';

export const theme = createTheme({
  status: {
    danger: '#e53e3e',
  },
  palette: {
    primary: {
      main: '#0971f1',
      darker: '#053e85',
    },
    neutral: {
      main: '#fff',
      contrastText: '#000',
    },
    turquoise: {
      main: '#79E1D5',
      contrastText: '#FFF'
    },
    valide: {
      main: '#91eeab',
      contrastText: '#FFF'
    },
    verdigris: {
      main: '#51B2A7',
      contrastText: '#FFF'
    },
    purple: {
      main: '#BF49A5',
      contrastText: '#FFF'
    },
    coral: {
      main: '#EF7070',
      contrastText: '#FFF'
    },
    grey: {
      main: '#BCC9C7',
      contrastText: "#000"
    },
    dark: {
      main: '#000',
      contrastText: "#FFF"
    }
  },
});

export const TokenContext = createContext();

function App() {
  const [token, setToken] = useState(sessionStorage.getItem('token'));

  if(!token) {
    return <TokenContext.Provider value={[token, setToken]}><ThemeProvider theme={theme}><SignIn setToken={setToken} /></ThemeProvider></TokenContext.Provider>
  }
  return (
    <TokenContext.Provider value={[token, setToken]}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="gestion_employes" element={<ManageUser />} />
          <Route path="gestion_conges" element={<ManageConge />} />
          <Route path="/" element={<Navigate to="dashboard" />} />
          <Route path="*" element={<Navigate to="dashboard" />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
    </TokenContext.Provider>
  );
}

export default App;
